import { Component, OnInit } from '@angular/core';
import { BookingService } from '../booking/booking.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {

  constructor(public booking: BookingService) { }

  ngOnInit(): void {
  }

}
